import { Menu } from 'antd';
import {
  DashboardOutlined,
  FileSearchOutlined,
  FolderOpenOutlined,
  ApiOutlined,
  SwapOutlined,
  UploadOutlined,
  UserOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

import { isAdmin, isStaff, useAuth, type AuthUser } from '../auth';

function buildItems(user: AuthUser | null) {
  const items: { key: string; icon: React.ReactNode; label: string }[] = [];

  if (isAdmin(user)) {
    items.push({ key: '/dashboard', icon: <DashboardOutlined />, label: 'Dashboard' });
  }
  if (isStaff(user)) {
    items.push({ key: '/reportes', icon: <FileSearchOutlined />, label: 'Reportes' });
    items.push({ key: '/match',    icon: <SwapOutlined />,       label: 'Conciliación Manual' });
    items.push({ key: '/estado-sat', icon: <ApiOutlined />,      label: 'Estado del SAT' });
    items.push({ key: '/cfdi-catalogo', icon: <DownloadOutlined />, label: 'Catálogo de CFDIs' });
  } else {
    items.push({ key: '/mis-conciliaciones', icon: <FolderOpenOutlined />, label: 'Mis Conciliaciones' });
  }
  if (isAdmin(user)) {
    items.push({ key: '/carga', icon: <UploadOutlined />, label: 'Carga de Archivos' });
    items.push({ key: '/usuarios', icon: <UserOutlined />, label: 'Usuarios' });
  }
  return items;
}

export function Sidebar() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const items = buildItems(user);

  // /reportes/:rfc/match pertenece a "Conciliación Manual", no a "Reportes"
  const selectedKey = /^\/reportes\/[^/]+\/match/.test(location.pathname)
    ? '/match'
    : items
        .map(i => i.key)
        .filter(k => location.pathname.startsWith(k))
        .sort((a, b) => b.length - a.length)[0] ?? items[0]?.key;

  return (
    <Menu
      mode="inline"
      theme="dark"
      selectedKeys={selectedKey ? [selectedKey] : []}
      items={items}
      onClick={({ key }) => navigate(key)}
      style={{ borderInlineEnd: 0 }}
    />
  );
}
